<template>
    <div class="privacy-limits">
        <div class="privacy-title">权限说明</div>
        <div v-if="Model == 'ios'" class="maskLimits">
            <p>为了保证您更好的体验投米，可能需要获得以下权限</p>
            <b style="margin-top:10px;">通知权限：</b>
            <span>用于获取平台最新活动、公告、资讯等重要消息通知</span>
            <b>电话权限：</b>
            <span>您在APP内点击客服电话时可直接拨打电话</span>
            <b>相机权限：</b>
            <span>用于上传头像</span>
        </div>
        <div v-else class="maskLimits">
            <p>为了保证您更好的体验投米，可能需要获得以下权限</p>
            <b style="margin-top:10px;">通知权限：</b>
            <span>用于获取平台最新活动、公告、资讯等重要消息通知</span>
            <b>电话权限：</b>
            <span>您在APP内点击客服电话时可直接拨打电话</span>
            <b>相机权限：</b>
            <span>用于上传头像</span>
            <b>存储权限：</b>
            <span>应用升级、读取相册时获取储存位置权限</span>
            <b>设备信息：</b>
            <span>用于统计设备识别码</span>
        </div>
    </div>
</template>
<script>
let u = navigator.userAgent;
let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
import { registerHandler } from "@/utils/bridge";
export default {
    data() {
        return {
            Model: "ios"
        };
    },
    created() {
        registerHandler("xhAppVersion").then(function(res) {
            res = JSON.parse(res);
            let osType = res.osType;
            if (osType.toLowerCase().indexOf("ios_toumi") > -1) {
                this.Model = "ios";
            } else {
                this.Model = "android";
            }
        });
    },

    methods: {}
};
</script>
<style lang="less" scoped>
.privacy-limits {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 16px;
    background-color: #fff;
    position: fixed;
    width: 100%;
    height: auto;
    .privacy-title {
        font-size: 18px;
        margin: 20px auto;
        text-align: center;
        font-weight: bolder;
    }
    /* 权限样式 ios和andor显示不同 */
    .maskLimits {
        p {
            font-size: 14px;
            color: #888888;
        }

        b {
            text-align: left;
            display: block;
            width: 100%;
            font-size: 14px;
            color: #333;
            margin-top: 10px;
        }

        span {
            font-size: 13px;
            text-align: left;
            display: block;
            width: 100%;
            margin-bottom: 10px;
            color: #666;
        }
    }
}
/* body,
html {
    background-color: #fff !important;
} */
</style>
